import { createApplicantFlowService } from 'src/api/applicant-flow';
import {
  createResidentApplicationService,
  fetchResidentApplicationApplicantInfoService,
  fetchResidentApplicationsService,
} from 'src/api/resident-application';
import useSWR from 'swr';
import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation';

export function useResidentApplications(skip?: boolean) {
  const {
    data: applications,
    error: applicationsError,
    isLoading: isLoadingApplications,
    isValidating: isValidatingStep,
    ...rest
  } = useSWR(!skip ? '/residents/applications' : null, (_key: string) => {
    return fetchResidentApplicationsService();
  });

  return {
    applications,
    applicationsError,
    isLoadingApplications,
    isValidatingStep,
    ...rest,
  };
}

export function useCreateResidentApplication(
  // `useSWRMutation` takes an `SWRMutationConfiguration`. This mutation's
  // trigger has no extra argument, so the third type argument stays `never`.
  options?: SWRMutationConfiguration<
    { applicationId: string },
    { message?: string },
    never,
    string
  >,
) {
  const {
    trigger: createApplication,
    error: creationError,
    isMutating: isCreatingApplication,
    ...rest
  } = useSWRMutation(
    '/residents/applications/create',
    async () => {
      const { applicationId } = await createResidentApplicationService();

      const mainApplicantInfo =
        await fetchResidentApplicationApplicantInfoService(applicationId);

      if (mainApplicantInfo.basicInfo?.residentId) {
        await createApplicantFlowService({
          mainApplicantResidentId: mainApplicantInfo.basicInfo?.residentId,
          coApplicantResidentIds: [],
        });
      }

      return { applicationId };
    },
    options,
  );

  return {
    createApplication,
    creationError,
    isCreatingApplication,
    ...rest,
  };
}
